import React, { FunctionComponent } from 'react'

import { getYear, Locale } from 'date-fns'

import { Box } from '@/atoms/layout'

import { StyledButton, StyledHeader, StyledSelect } from './styled-datepicker-header'

export interface MonthpickerHeaderProps {
  date: Date
  prevYearButtonDisabled: boolean
  nextYearButtonDisabled: boolean
  changeYear: (year: number) => void
  decreaseMonth: () => void
  decreaseYear: () => void
  increaseYear: () => void
}

interface Props {
  params: MonthpickerHeaderProps
  locale: Locale
  maxDate?: Date
  minDate?: Date
}

const DatepickerHeader: FunctionComponent<Props> = ({ params, minDate, maxDate }) => {
  const { date, changeYear, decreaseYear, prevYearButtonDisabled, increaseYear, nextYearButtonDisabled } = params

  const years = Array.from({ length: getYear(maxDate) - getYear(minDate) + 1 }, (_, i) => getYear(maxDate) - i)

  const handleYearChange = ({ target: { value } }): void => changeYear(value)

  return (
    <StyledHeader>
      <StyledButton onClick={decreaseYear} disabled={prevYearButtonDisabled} type="button">
        {'<'}
      </StyledButton>
      <Box>
        <StyledSelect onChange={handleYearChange} value={getYear(date)}>
          {years.map(year => (
            <option value={year} key={year}>
              {year}
            </option>
          ))}
        </StyledSelect>
      </Box>
      <StyledButton type="button" onClick={increaseYear} disabled={nextYearButtonDisabled}>
        {'>'}
      </StyledButton>
    </StyledHeader>
  )
}

export default DatepickerHeader
